import { metricPeriods, type MetricPeriod } from '@manaro/contracts'
import { cn } from '@/shared/lib/cn.ts'

export function PeriodSwitch({ value, onChange }: { value: MetricPeriod; onChange: (period: MetricPeriod) => void }) {
  return (
    <div className="flex gap-1 rounded-full border border-line bg-surface-soft p-1">
      {metricPeriods.map((period) => (
        <button
          key={period}
          type="button"
          aria-pressed={period === value}
          onClick={() => onChange(period)}
          className={cn(
            'rounded-full px-3.5 py-1.5 text-[13.5px] font-medium whitespace-nowrap transition-colors',
            period === value ? 'bg-brand text-white' : 'text-neutral-ink hover:bg-surface-hover',
          )}
        >
          {period}
        </button>
      ))}
    </div>
  )
}
